import React from "react";
import { Carousel } from "react-responsive-carousel";

import Icon from "../Icon";
import Button from "../Button";
import Modal from "../Modal";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./index.scss";

export default class DemoCarousel extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      modal: false
    };
  }

  onChange = (value) => {
    this.setState({ value });
  };

  render() {
    const { state, onChange, props } = this;
    const { children, options, galleryButton } = props;
    const { value, modal } = state;

    const defaultOptions = {
        showArrows : true,
        showStatus : false,
        showIndicators : false,
        infiniteLoop : false,
        showThumbs : false,
        useKeyboardArrows : true,
        autoPlay : false,
        stopOnHover : true,
        swipeable : true,
        dynamicHeight : true,
        emulateTouch : true,
        centerMode : true,
        centerSlidePercentage : 100,
    }

    const configOptions = {
        ...defaultOptions,
        ...options
    }

    return (
      <div className="carousel">
          {galleryButton && <Icon size={24} icon={"modal-gallery-button"} className="galleryButton" onClick={() => this.setState({ modal: true })}/>}        
          <Carousel
              selectedItem={value}
              onChange={onChange}
              {...configOptions}
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                      <button className="prev" type="button" onClick={onClickHandler} title={label}>
                          <Icon icon={"arrow-text-link-left"} size={14} />
                      </button>
                  )
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                      <button className="next" type="button" onClick={onClickHandler} title={label} >
                          <Icon icon={"arrow-text-link-right"} size={14} />
                      </button>
                  )
              }
              renderThumbs={()=> children}
              >
              {children}
          </Carousel>
          <Modal
            backDropClassName="backDrop"
            open={modal}
            className="galleryModal"
            closeFn={() => this.setState({ modal: false })}
            closeOnBackDrop={true}
            footerContent={
                <React.Fragment>
                    <Button onClick={() => this.setState({ modal: false })} className="secondary">Close</Button>
                </React.Fragment>
            }
        >
            <div className="body">
                <Icon onClick={() => this.setState({ modal: false })} className={"closeGallery"} icon={"feather-x-square"} />
                <Carousel
                  selectedItem={value}
                  onChange={onChange}
                  {...defaultOptions}
                  showStatus={true}
                  statusFormatter={(current, total) => { return current + " / " + total }}
                  renderArrowPrev={(onClickHandler, hasPrev, label) =>
                      hasPrev && (
                          <button className="prev" type="button" onClick={onClickHandler} title={label}>
                              <Icon icon={"arrow-text-link-left"} size={14} />
                          </button>
                      )
                  }
                  renderArrowNext={(onClickHandler, hasNext, label) =>
                      hasNext && (
                          <button className="next" type="button" onClick={onClickHandler} title={label} >
                              <Icon icon={"arrow-text-link-right"} size={14} />
                          </button>
                      )
                  }
                  renderThumbs={()=> children}
                >
                  {children}
              </Carousel>
            </div>
        </Modal>                        
      </div>
      
    );
  }
}
